import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialIndoorAnalyticsState from './indoor-analytics-initial-state';
import {
    IndoorCrashLocationsResult,
    IndoorFlowsResult,
    IndoorLaneUsageResult,
    IndoorLiveResult,
    IndoorSummary,
    IndoorZoneTimeResult,
    KeyedResult
} from '../models/indoor-analytics.model';

const indoorAnalyticsSlice = createSlice({
    name: 'indoorAnalyticsSlice',
    initialState: initialIndoorAnalyticsState,
    reducers: {
        setIndoorSummary(state, { payload }: PayloadAction<KeyedResult<IndoorSummary> | null>) {
            state.summary = payload;
        },
        setIndoorZoneTime(state, { payload }: PayloadAction<KeyedResult<IndoorZoneTimeResult> | null>) {
            state.zoneTime = payload;
        },
        setIndoorLaneUsage(state, { payload }: PayloadAction<KeyedResult<IndoorLaneUsageResult> | null>) {
            state.laneUsage = payload;
        },
        setIndoorFlows(state, { payload }: PayloadAction<KeyedResult<IndoorFlowsResult> | null>) {
            state.flows = payload;
        },
        setIndoorCrashLocations(state, { payload }: PayloadAction<KeyedResult<IndoorCrashLocationsResult> | null>) {
            state.crashLocations = payload;
        },
        setIndoorLive(state, { payload }: PayloadAction<KeyedResult<IndoorLiveResult> | null>) {
            state.live = payload;
        }
    }
});

export const {
    setIndoorSummary,
    setIndoorZoneTime,
    setIndoorLaneUsage,
    setIndoorFlows,
    setIndoorCrashLocations,
    setIndoorLive
} = indoorAnalyticsSlice.actions;

export default indoorAnalyticsSlice.reducer;
